export const SHIFT_WORK_TYPES = {
    POOL: "pool",
    DEDICATED: "dedicated",
    DEDICATED_INTEGRATION: "dedicatedIntegration"
};

// Havuz ve sabit entegre aynı havuz vardiya ucundan besleniyor; ayrım isteğe geçilen
// integrationType parametresiyle yapılıyor. Sabit (düz dedike) ise puantaj listesinden gelir.
export const isPoolWorkType = workType =>
    workType === SHIFT_WORK_TYPES.POOL || workType === SHIFT_WORK_TYPES.DEDICATED_INTEGRATION;
